import React from 'react'
import { IFormattedDataByCustomer } from './types/customerDataItem'
import DropdownWrapper from './ui/DropdownWrapper';
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon';
import SectionProductWrapper from './ui/SectionProductWrapper';
import NestedItem from './NestedItem';
import { ITransportationOrderDetail } from '../../../../../../modules/API/Seller/models/transportation';

interface ITransportationCustomerItemProp {
  customer: IFormattedDataByCustomer
  handleChangePrice: (price: number[], item: ITransportationOrderDetail) => void
  handlePrintByCustomer: (OrderID: number) => void
}

const TransportationCustomerItem = (props: ITransportationCustomerItemProp) => {
  const { customer, handleChangePrice, handlePrintByCustomer } = props;
  const isExistOrder = customer.OrderDetails.length > 0;
  const handlePrint = () => {
    if(isExistOrder) {
      handlePrintByCustomer(customer.OrderDetails[0]?.product.OrderID)
    }
  }
  return (
    <DropdownWrapper
      title={customer.Customer_Name}
      icon={<UserIcon />}
      handlePrint={isExistOrder ? handlePrint : undefined}
    >
      {customer.OrderDetails.map((order) => (
        <SectionProductWrapper 
          list={order.byGrower}
          product={order.product} 
          key={`${order.product.ProductID}-${order.product.VarietyID}-${order.product.SizeID}-${order.product.GrowerID}`}
        >
            {order.byGrower.map((grower, index) => (
              <NestedItem
                key={grower.GrowerID}
                title={grower.GrowerName}
                defaultPrice={[grower.ExpectedPriceFrom, grower.ExpectedPriceTo]}
                index={index}
                item={grower}
                handleChangePrice={handleChangePrice}
                palletQty={grower.Order_Pallets}
              />  
          ))}
        </SectionProductWrapper>
      ))}
    </DropdownWrapper>
  )
}

export default TransportationCustomerItem